import React from "react";

function About() {
  return (
    <div name="about" className="w-full h-screen bg-[#F3DFBF]">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline-block border-b-4 border-[#008148] text-[#008148]">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-3xl font-bold">
            <p>
              Sono una persona volenterosa, abituata a lavorare in gruppo e con
              molta passione per l'informatica.
            </p>
          </div>
          <div>
            <p className="text-xl">
              Attualmente sto frequentando un corso IFTS di programmazione Java
              e tecniche per la progettazione e la gestione di database erogato
              dalla fondazione et-labora a Bergamo. Ho scelto di intraprendere
              questo percorso essendo l'informatica una mia passione e volevo
              ampliare e approfondire le mie conoscenze cosi da poterle
              implementare in ambito lavorativo. Per il completamento di tale
              percorso e il conseguente raggiungimento del diploma IFTS, sono
              richieste 470 ore di tirocinio curriculare. Il tirocinio inizierà
              dal mese di giugno. Nel tempo libero cerco di approfondire e
              migliorare le mie conoscenze in ambito informatico, ad esempio
              conoscere nuove tecnologie, provare nuovi linguaggi di
              programmazione o framework, guardando tutorial online o tramite la
              documentazione.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
